{
  "version": 1,
  "asset_id": "033edf91-1e79-40ce-946e-b2450529f265",
  "project_id": "115256dd-a6cc-4bc1-95c1-d787d4c0e481",
  "url": "/__l5e/assets-v1/033edf91-1e79-40ce-946e-b2450529f265/marine-thumb.webp",
  "r2_key": "a/v1/115256dd-a6cc-4bc1-95c1-d787d4c0e481/033edf91-1e79-40ce-946e-b2450529f265/marine-thumb.webp",
  "original_filename": "marine-thumb.webp",
  "size": 5748,
  "content_type": "image/webp",
  "created_at": "2026-06-27T00:31:08Z"
}
